(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["keltek-collection-filter"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const filter = document.querySelector('.kcfilter');
    if (!filter) return;

    filter.addEventListener('click', (e) => {
      const pill = e.target.closest('.kcfilter__pill');
      if (!pill) return;

      e.preventDefault();
      const url = pill.href;

      const row = pill.closest('.kcfilter__inner');
      row.querySelectorAll('.kcfilter__pill').forEach(p => p.classList.remove('kcfilter__pill--active'));
      pill.classList.add('kcfilter__pill--active');

      history.pushState({}, '', url);

      const grid = document.getElementById('ResultsList');
      if (grid) grid.style.opacity = '0.4';

      fetch(url)
        .then(r => r.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newGrid = doc.getElementById('ResultsList');
          if (newGrid && grid) {
            grid.innerHTML = newGrid.innerHTML;
            grid.style.opacity = '1';
          }
        })
        .catch(() => {
          if (grid) grid.style.opacity = '1';
        });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keltek-mobile-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initKeltekNav() {
      const overlay = document.getElementById('keltekMobileNav');
      if (!overlay) return;

      // Move out of header so position:fixed is relative to the viewport
      document.body.appendChild(overlay);

      function resetDrawer() {
        const drawer = document.querySelector('.menu-drawer-container');
        if (drawer) {
          drawer.removeAttribute('open');
          drawer.classList.remove('menu-open');
        }
      }

      function openNav() {
        overlay.classList.add('kmobilenav--open');
        overlay.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }

      function closeNav() {
        overlay.classList.remove('kmobilenav--open');
        overlay.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        resetDrawer();
      }

      // Event delegation for close button and nav links
      overlay.addEventListener('click', (e) => {
        if (e.target.closest('.kmobilenav__close')) {
          closeNav();
        } else if (e.target.closest('a')) {
          closeNav();
        }
      });

      // Watch the drawer element for when it opens — intercept regardless of
      // which listener toggles it (theme JS may fire before ours in capture phase)
      function hookHamburger() {
        if (window.innerWidth >= 750) return;
        const drawer = document.querySelector('.menu-drawer-container');
        if (!drawer || drawer._keltekHooked) return;
        drawer._keltekHooked = true;

        const obs = new MutationObserver(() => {
          if (drawer.classList.contains('menu-open')) {
            obs.disconnect();
            drawer.removeAttribute('open');
            drawer.classList.remove('menu-open');
            if (window.innerWidth < 750) openNav();
            obs.observe(drawer, { attributes: true, attributeFilter: ['class', 'open'] });
          }
        });
        obs.observe(drawer, { attributes: true, attributeFilter: ['class', 'open'] });
      }

      hookHamburger();

      window.addEventListener('resize', () => {
        if (window.innerWidth >= 750) closeNav();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initKeltekNav);
    } else {
      initKeltekNav();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
